import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';

interface ErrorMessageDisplayProps {
	message: string;
}

const ErrorMessageDisplay: React.FC<ErrorMessageDisplayProps> = ({ message }) => {
	if (!message) return null;

	return (
		<div className="mb-4 p-4 bg-red-50 border border-red-200 rounded">
			<div className="text-red-700">
				<Typography size="sm">{message}</Typography>
			</div>
		</div>
	);
};

export default ErrorMessageDisplay;
